import * as angular from "angular";
import { IInstanceSettings } from "../../typings/board/Models";
import { USERS_SERVICE, UsersService } from './../users/users.service';

export const DASHBOARD_DIALOG_SERVICE = "dashboardDialogService";

export class DashboardDialogService {

    static $inject = ["$q", "$timeout", "$mdDialog"];
    constructor(private $q: ng.IQService, private $timeout: ng.ITimeoutService, private $mdDialog: ng.material.IDialogService) { }

    public createUserDialog(settings: IInstanceSettings): ng.IPromise<any> {
        if (angular.isUndefined(settings) || settings.initialized) { return this.$q.reject(); }

        return this.$mdDialog.show({
            controller: CreateUserDialogController,
            controllerAs: "$ctrl",
            template: require("./dashboard-create-user-dialog.html"),
            focusOnOpen: true,
            clickOutsideToClose: true,
            escapeToClose: true,
            bindToController: true,
            fullscreen: true,
            locals: { "settings": settings }
        }).then((response: any) => {
            return this.$q.resolve(response);
        },
            () => {
                return this.$q.reject();
            });
    }
}

export class CreateUserResponse {

    private username: string;
    private password: string;
    private confirmPassword: string;
}

export class CreateUserDialogController {

    private settings: IInstanceSettings;
    private wait: boolean;
    private username = "Administrator";
    private password: string;
    private confirmPassword: string;
    private confirmPasswordErrorMsg: string;

    get settingInitialized() { return angular.isDefined(this.settings) && angular.isDefined(this.settings.initialized) ? this.settings.initialized : false; }

    get titleLabel() { return "Create first BOARD user"; }

    get usernameLabel() { return "Username"; }
    get passwordLabel() { return "Password"; }
    get confirmPasswordLabel() { return "Confirm password"; }
    get createButtonLabel() { return "Create"; }
    get cancelButtonLabel() { return "Cancel"; }

    get notMatchMsg() { return "Passwords doesn't match"; }
    get charactersLong() { return "Password must be at least 8 characters long"; }
    get existsOrNotRunning() { return "Administrator already exists or server not running"; }

    static $inject = ["$q", "$timeout", "$mdDialog", USERS_SERVICE];
    constructor(private $q: ng.IQService, private $timeout: ng.ITimeoutService,
        private $mdDialog: ng.material.IDialogService,
        private usersService: UsersService) { }

    private createFirstUser(password: string, confirm: string): ng.IPromise<void> {
        this.confirmPasswordErrorMsg = undefined;
        if (password !== confirm) {
            this.confirmPasswordErrorMsg = this.notMatchMsg;
            return this.$q.reject();
        }

        if (password.length < 8) {
            this.confirmPasswordErrorMsg = this.charactersLong;
            return this.$q.reject();
        }

        this.wait = true;

        return this.usersService.createFirstUser(password)
            .then(() => {
                this.settings.initialized = true;
                return this.$q.resolve();
            }, reason => {
                this.confirmPasswordErrorMsg = reason.data.message !== "" ? reason.data.message : this.existsOrNotRunning;
                return this.$q.reject(reason);
            })
            .finally(() => { this.wait = false; });
    }

    private onCancel() {
        this.$mdDialog.cancel();
    }

    private onCreate() {
        this.createFirstUser(this.password, this.confirmPassword).then(
            () => { this.$mdDialog.hide({}); }

        );
    }

}


// WEBPACK FOOTER //
// ./app/dashboard/dashboard-create-user-dialog.controller.ts